import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Wraps routes that require an authenticated user.
 * Not authenticated → redirect to login. Otherwise render children.
 */
const ProtectedRoute = ({ children, isAuthenticated }) => {
    if (!isAuthenticated) {
        return <Navigate to="/account/login" replace />;
    }
    return children;
};

export default ProtectedRoute;
